import React, { useState, useEffect } from 'react'
import { Panel, Placeholder, Table } from 'rsuite'
import './styles.less'
const { Column, HeaderCell, Cell } = Table
const { Paragraph } = Placeholder

export default function TableLoadingTemplate() {
  return (
    <div className="table-loading-template">
      <Panel shaded bordered defaultExpanded>
        <Paragraph style={{ width: '10em' }} rows={1} />
        <br />
        <Table
          loading={true}
          height={400}
          //renderLoading={}
          data={mockArray}
        >
          <Column flexGrow={1}>
            <HeaderCell />
            <Cell>
              {(rowData) => {
                return <Paragraph />
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </div>
  )
}

const mockArray = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
  {
    id: 4,
  },
  {
    id: 5,
  },
]
